import moment from "moment";

export class MeetingRoomScheduleInput {
    public fromDateTime: moment.Moment = moment(moment.now(), 'YYYY-MM-DD').utc(false);
    public toDateTime: moment.Moment = moment(moment.now(), 'YYYY-MM-DD').utc(false);
    public meetingRoomId = 0;
    public customerId: number | null = null;
    public description = '';
    public employeeWhoAttendToTheMeetingIds: Array<number> = [];
    public otherCustomerName = '';
}
